export const SUPER_ADMIN_ONLY_KEYS = [
  "staff", "usermanagement", "hrusers", "facilityportal", "communication-management",
  "contactdetails", "businessinsurance", "certificates", "statements", "vehicle", "setting",
];

// Same rule the old top nav applied: login/main-menu set user_type
// (S/M/A, or H/U/F/T/C when a manager picks one module), and only entries
// whose `type` lists it are shown — single-module users see no nav at all.
export const matchesNavUserType = (menuType, userType) => {
  if (menuType == null) {
    return true;
  }
  if (Array.isArray(menuType)) {
    return menuType.includes(userType) || menuType.includes(null);
  }
  return menuType === userType;
};

// Module ids the user is licensed for, from login (stored comma-separated).
export const getUserModuleIds = () =>
  (localStorage.getItem("module_id") || "").split(",").map((id) => id.trim()).filter(Boolean);

// Login treats everyone who isn't a super admin (or the system owner) as a
// manager and only offers them their licensed modules (the /menu tiles) —
// whatever user_type it stored (M or A). Managers get exactly those modules.
export const isManagerUser = (isSuperAdmin, userType) => !isSuperAdmin && userType !== "S";

// Cleaning Excellence and Asepsis Loop (`managerAccess`) show for managers as
// well: the link signs them in where the module is assigned to them, and
// otherwise says why it can't.
const isLicensedModule = (menu) => !!menu.managerAccess || (!!menu.moduleId && getUserModuleIds().includes(menu.moduleId));

// `managerOnly` entries (the managers' own Dashboard link) show for managers
// only; admins reach the same page through the Admin entry.
export const isTopLevelNavVisible = (menu, isSuperAdmin, userType) => {
  if (menu.managerOnly) {
    return isManagerUser(isSuperAdmin, userType);
  }
  return isManagerUser(isSuperAdmin, userType)
    ? isLicensedModule(menu)
    : matchesNavUserType(menu.type, userType) && !(SUPER_ADMIN_ONLY_KEYS.includes(menu.key) && !isSuperAdmin);
};

export const pathMatches = (path, pathname) =>
  !!path && (pathname === path || pathname.startsWith(`${path}/`));

export const isNavEntryActive = (menu, pathname) =>
  pathMatches(menu.path, pathname) || (menu.submenu || []).some((sub) => pathMatches(sub.path, pathname));

export const findActiveNavEntry = (menus, pathname) => menus.find((menu) => isNavEntryActive(menu, pathname));

// A top-level entry with sub-pages (Admin, Workforce) has no path of its own;
// it lands on its first sub-page, the rest are reached via the page's tab bar.
export const getNavEntryHref = (menu) => menu.path || (menu.submenu || []).find((sub) => sub.path)?.path;
